import {Route, Routes} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {AuthLayout} from './AuthLayout'
import { RecoveryPassword } from './components/RecoveryPassword'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path='login' element={<Login />} />
      <Route path='registration/:hash' element={<Registration />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='recuperar_conta/:hash' element={<RecoveryPassword />}/>
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
